import { VStack, Heading, Button, Stack, Flex, SimpleGrid } from '@chakra-ui/react'
import { useContext, useState } from 'react'
import { shortAddress } from '../../utils/minorUtils'
import {
  usePrepareContractWrite,
  useContractWrite,
  useWaitForTransaction,
  useContractRead,
  useContractEvent,
} from 'wagmi'
import TicTacToeABI from '../../assets/constants/abi/TicTacToe.json'
import TicTacToeGameABI from '../../assets/constants/abi/TicTacToeGame.json'
import NetworkMapping from '../../assets/constants/network-mapping.json'
import { TicTacToeContext } from '../../context/TicTacToeContext'

const GameBoard = () => {
  const { setGameDetails, gameDetails } = useContext(TicTacToeContext)
  const [location, setLocation] = useState()
  const [wonFilter, setWonFilter] = useState<Number[]>()
  const { refetch: refetchGameBoard } = useContractRead({
    address: NetworkMapping['80001']['TicTacToe'] as `0x${string}`,
    abi: TicTacToeABI,
    functionName: 'getGameBoard',
    args: [gameDetails.gameId],
    watch: false,
    onSuccess(gameState: any) {
      setGameDetails({
        ...gameDetails,
        gameBoard: gameState,
      })
      setLocation(undefined)
      setChoiceArray(
        gameState.map((ele: any) => {
          if (ele === gameDetails.playerOne) return 'X'
          if (ele === gameDetails.playerTwo) return 'O'
          return '-'
        })
      )
    },
  })

  const { refetch } = useContractRead({
    address: NetworkMapping['80001']['TicTacToe'] as `0x${string}`,
    abi: TicTacToeABI,
    functionName: 'getGameDetails',
    args: [gameDetails.gameId],
    enabled: gameDetails.gameId >= 0,
    onSuccess(gameState: any) {
      setGameDetails({
        ...gameDetails,
        state: gameState[3],
        winner: gameState[4],
      })
    },
  })

  useContractEvent({
    address: gameDetails.address as `0x${string}`,
    abi: TicTacToeGameABI,
    eventName: 'GameEnded',
    listener() {
      refetch()
      getWinningLocations()
    },
  })

  const { config, isError: isPrepareError } = usePrepareContractWrite({
    address: NetworkMapping['80001']['TicTacToe'] as `0x${string}`,
    abi: TicTacToeABI,
    functionName: 'placeMove',
    enabled: location! >= 0 && location! < 9,
    args: [gameDetails.gameId, location],
  })

  const { data, isError, write: placeMove } = useContractWrite(config)

   useWaitForTransaction({
    hash: data?.hash,
    onSuccess(data) {
      refetchGameBoard()
    },
  })

  type choice = 'O' | 'X' | '-'

  const [choiceArray, setChoiceArray] = useState<choice[]>([
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
  ])

  // useEffect(() => {
  //   setChoiceArray(
  //     gameDetails.gameBoard.map((ele: any) => {
  //       if (ele === gameDetails.playerOne) return 'X'
  //       if (ele === gameDetails.playerTwo) return 'O'
  //       return '-'
  //     })
  //   )
  // }, [gameDetails.gameBoard])

  function takeAction(index: any) {
    setLocation(index)
    // refetch?.()
    //write?.()
  }

  function getWinningLocations() {
    let winningfilters = [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [0, 3, 6],
      [1, 4, 7],
      [2, 5, 8],
      [0, 4, 8],
      [6, 4, 2],
    ]

    for (let i = 0; i < winningfilters.length; i++) {
      let filter = winningfilters[i]
      if (
        gameDetails.gameBoard[filter[0]] !== '-' &&
        gameDetails.gameBoard[filter[0]] === gameDetails.gameBoard[filter[1]] &&
        gameDetails.gameBoard[filter[1]] === gameDetails.gameBoard[filter[2]]
      ) {
        setWonFilter(filter)
        break
      }
    }
  }

  return (
    <VStack minW={{ base: 'md', md: 'md', lg: 'md' }}>
      <Heading fontSize={'2xl'}>{`Game Id: ${gameDetails.gameId}`}</Heading>
      <Flex alignItems={'center'} justify={'center'}>
        <SimpleGrid columns={3} spacing={5} py={'6'}>
          {choiceArray.map((choice, index) => {
            return (
              <Stack
                bg={
                  wonFilter?.includes(index)
                    ? 'brand.500'
                    : location === index
                    ? 'tomato'
                    : 'red.100'
                }
                height="100px"
                width="100px"
                borderRadius={'full'}
                textAlign={'center'}
                justifyContent={'center'}
                textColor={'second.500'}
                key={index}
                onClick={(e) => takeAction(index)}
                _hover={{
                  cursor: gameDetails.state === 0 ? 'pointer' : 'not-allowed',
                  boxShadow: gameDetails.state === 0 ? '1px 5px 2px' : '',
                }}
              >
                <Heading as={'h1'} fontSize={'5xl'}>
                  {choice}
                </Heading>
              </Stack>
            )
          })}
        </SimpleGrid>
      </Flex>
      {gameDetails.state === 1 && (
        <Heading fontSize={'lg'}> {`The Winner is ${shortAddress(gameDetails.winner)}`}</Heading>
      )}
      {gameDetails.state === 2 && <Heading fontSize={'lg'}> Game Ended in a Draw</Heading>}

      {gameDetails.state === 0 && (
        <Button
          colorScheme="teal"
          variant="outline"
          isDisabled={isError || isPrepareError}
          onClick={(e) => {
            e.preventDefault()
            placeMove?.()
          }}
        >
          {`Make a Move`}
        </Button>
      )}
    </VStack>
  )
}
export default GameBoard
